<template>
  <div class="mission-top-page">
    <header-pane pageTitle="MISSION" colorType="light" />
    <div class="mission-top-page__contents">
      <router-view />
    </div>
    <global-navigation-pane current="mission" />
  </div>
</template>

<script lang="ts">
import { defineComponent, onUnmounted } from '@vue/composition-api'
import HeaderPane from '@/components/common/Header/HeaderPane.vue'
import GlobalNavigationPane from '@/components/common/GlobalNavigation/GlobalNavigationPane.vue'
import StoreUtil from '@/store/StoreUtil'

/**
 * ミッションページ
 */
export default defineComponent({
  name: 'MissionTopPage',
  components: { GlobalNavigationPane, HeaderPane },
  setup() {
    const missionPageStore = StoreUtil.useStore('MissionPageStore')
    const { clearMissionPageData } = missionPageStore
    onUnmounted(() => {
      clearMissionPageData()
    })
  },
})
</script>

<style scoped lang="scss">
.mission-top-page {
  display: flex;
  flex-direction: column;
  height: var(--screen-height);
  padding-bottom: var(--safe-area-inset-bottom);
  background-color: $black20;

  &__contents {
    height: calc(100% - 48px - 48px);
  }
}
</style>
